<template>
  <section>
    <h2 class="light">{{ $t("plan.planAdmins.header") }}</h2>
    <a
      v-if="enabled"
      @click="showModal = true"
      class="button light"
    >
      {{ $t("plan.planAdmins.button.add") }}
    </a>
    <h3 class="light" v-if="enabled"> {{ $t("plan.planAdmins.invitationsLeft") }}: <span class="error">{{ invitationsLeft }}</span></h3>
    <Modal v-if="showModal" v-bind:modalTitle="$t('plan.planAdmins.modal.header')" @close="closeModal">
      <PlanInviteForm v-bind="{ planId: this.planId, invitationsLeft: this.invitationsLeft, clickLimit: this.invitationsLeft-1}" />
    </Modal>
    <Loader v-if="!ownersLoaded"/>
    <table v-if="ownersLoaded" id="groups">
      <caption class="caption">PlanAdmins table</caption>
      <tr class="header">
        <th scope="col">{{ $t("plan.planAdmins.table.name") }}</th>
        <th scope="col">{{ $t("plan.planAdmins.table.email") }}</th>
        <th scope="col" v-if="enabled">{{ $t("plan.planAdmins.table.actions") }}</th>
      </tr>
      <tr v-for="(owner, index) in owners" v-bind:key="index">
        <td>{{ owner.givenName + ' ' + owner.familyName }}</td>
        <td>{{ owner.emailAddress }}</td>
        <td v-if="enabled"><DeleteAdmin
          v-if="owners.length > 1"
          v-bind:adminName="owner.givenName + ' ' + owner.familyName"
          v-bind:appUserId="owner.userId"
          v-bind:planId="planId"/>
        </td>
      </tr>
    </table>
  </section>
</template>

<script>
import Loader from '@/components/Loader.vue'
import Modal from '@/components/Modal.vue'
import PlanInviteForm from '@/components/plan/InviteForm.vue'
import DeleteAdmin from '@/components/plan/DeleteAdmin.vue'

import { planService } from '@/services/plan.service'

export default {
  props: ['planId', 'enabled'],
  name: 'PlanAdmins',
  components: {
    Loader,
    Modal,
    PlanInviteForm,
    DeleteAdmin
  },
  data: function () {
    return {
      owners: {},
      ownersLoaded: false,
      showModal: false,
      currentPlanMembers: 0,
      maxPlanMembers: 0,
      invitationsLeft: 0
    }
  },
  mounted: function () {
    this.fetchAdmins()
    this.calInvitationsLeft()
  },  
  methods: {
    fetchAdmins: function () {
      // Get admins for the plan
      planService.owners(this.planId).then(owners => {
        //console.log(owners)
        this.owners = owners
        this.ownersLoaded = true
      }).catch(err => {
        console.error('Unable to fetch plan admins: ', err)
      })
    },
    calInvitationsLeft: function () {
      // Get admins for the plan
      planService.getCurrentPlanMembers(this.planId).then(plan => {
      this.currentPlanMembers = plan
      this.$forceUpdate()

        planService.getPlan(this.planId).then(plan => {
          this.maxPlanMembers = plan.maxPlanMembers
          this.$forceUpdate()
          this.invitationsLeft = this.maxPlanMembers - this.currentPlanMembers
        })
      })
    },
    closeModal: function (event) {
      this.showModal = false
      this.$router.go(0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
section {
  margin-bottom: 60px;
  max-width: 700px;
}

h2 {
  color: $primary;
  font-weight: $regular;
  float: left;
  margin-right: 40px;
  margin-bottom: 20px;
}

h3 {
  color: $primary;
  font-weight: $regular;
  float: left;
  margin-right: 40px;
  margin-left: 10px;
  margin-top: 10px;
}

a.button.light {
  float: left;
  margin: 7px 0;
}

table {
  width: 100%;
  margin-top: 17px;
  border-collapse: collapse;
  .caption {
    display: none;
  }
}

tr.header {
  color: $text-light;
  background: $primary;
  th {
    text-align: left;
    border: none;
    padding: 7px 0 7px 28px;
  }
}

td {
  text-align: left;
  background: $surface-alpha;
  border-bottom: 2px solid $surface-beta;
  padding: 21px 0 21px 28px;

  .launch {
    background: url('../../assets/icons/launch.png') no-repeat left center;
    padding-left: 30px;
  }
}
</style>
